var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuMemoDActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_memo_d_active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 25,
    viewBox: "0 0 70 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H18.753V20.458H0Z",
    fill: "#5d9df0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_207004",
    "data-name": "\\uC0AC\\uAC01\\uD615 207004",
    width: 70,
    height: 25,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1647",
    "data-name": "\\uADF8\\uB8F9 1647",
    transform: "translate(5.381 -5.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(20.62 8.8)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M14.671,20.458H4.081A4.06,4.06,0,0,1,0,16.429V4.028A4.059,4.059,0,0,1,4.081,0h10.59a4.06,4.06,0,0,1,4.082,4.028v12.4a4.06,4.06,0,0,1-4.082,4.03ZM4.081,1.976A2.068,2.068,0,0,0,2,4.028v12.4a2.069,2.069,0,0,0,2.08,2.053H14.67a2.069,2.069,0,0,0,2.081-2.053V4.028A2.069,2.069,0,0,0,14.67,1.976Z",
    fill: "#5d9df0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M8.1,1.7H.989A.929.929,0,0,1,0,.852.929.929,0,0,1,.989,0H8.1a.929.929,0,0,1,.989.852A.929.929,0,0,1,8.1,1.7",
    transform: "translate(25.166 14.483)",
    fill: "#5d9df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M8.1,1.7H.989A.929.929,0,0,1,0,.852.929.929,0,0,1,.989,0H8.1a.929.929,0,0,1,.989.852A.929.929,0,0,1,8.1,1.7",
    transform: "translate(25.166 18.461)",
    fill: "#5d9df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M8.1,1.7H.989A.929.929,0,0,1,0,.852.929.929,0,0,1,.989,0H8.1a.929.929,0,0,1,.989.852A.929.929,0,0,1,8.1,1.7",
    transform: "translate(25.166 22.439)",
    fill: "#5d9df0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMemoDActive);
export default __webpack_public_path__ + "static/media/menu_memo_d_active.6c2eb7339e5943d2ea22b01c362cc712.svg";
export { ForwardRef as ReactComponent };